export default __webpack_public_path__ + "static/media/csv-cancelled.14e91239.svg";